import {
    FETCH_ACCOUNTS,
    FETCH_ACCOUNTS_ERROR,
    FETCH_ACCOUNTS_SUCCESS,
    LOAD_ACCOUNTS_DETAIL,
    ACCOUNTS_DETAIL_ERROR,
    ACCOUNTS_UNMOUNT_DETAIL,
    FETCH_ACCOUNT_SETTINGS,
    FETCH_ACCOUNT_SETTINGS_ERROR,
    FETCH_ACCOUNT_SETTINGS_SUCCESS,
    UPDATE_ACCOUNT_GENERAL_SETTINGS,
    UPDATE_ACCOUNT_GENERAL_SETTINGS_SUCCESS,
    UPDATE_ACCOUNT_GENERAL_SETTINGS_ERROR,
    REGISTER_USER,
    REGISTER_USER_SUCCESS,
    REGISTER_USER_ERROR,

    // Account Invoices
    FETCH_ACCOUNT_INVOICES,
    FETCH_ACCOUNT_INVOICES_SUCCESS,
    FETCH_ACCOUNT_INVOICES_ERROR,
} from './constants';

export const fetchAccounts = (groups) => ({
    type: FETCH_ACCOUNTS,
    payload: { groups },
});

export const fetchAccountsSuccess = (payload) => ({
    type: FETCH_ACCOUNTS_SUCCESS,
    payload,
});

export const fetchAccountsError = () => ({
    type: FETCH_ACCOUNTS_ERROR,
});

export const fetchAccountDetail = (accountId) => ({
    type: LOAD_ACCOUNTS_DETAIL,
    payload: accountId,
});

export const fetchAccountDetailError = () => ({
    type: ACCOUNTS_DETAIL_ERROR,
});

export const fetchAccountUnmount = () => ({
    type: ACCOUNTS_UNMOUNT_DETAIL,
});

export const fetchAccountSettings = (accountId) => ({
    type: FETCH_ACCOUNT_SETTINGS,
    payload: accountId,
});

export const fetchAccountSettingsError = () => ({
    type: FETCH_ACCOUNT_SETTINGS_ERROR,
});

export const fetchAccountSettingsSuccess = (payload) => ({
    type: FETCH_ACCOUNT_SETTINGS_SUCCESS,
    payload,
});

export const updateAccountGeneralSettings = (accountId, data, message) => ({
    type: UPDATE_ACCOUNT_GENERAL_SETTINGS,
    payload: { accountId, data },
    message,
});

export const updateAccountGeneralSettingsSuccess = (payload) => ({
    type: UPDATE_ACCOUNT_GENERAL_SETTINGS_SUCCESS,
    payload,
});

export const updateAccountGeneralSettingsError = () => ({
    type: UPDATE_ACCOUNT_GENERAL_SETTINGS_ERROR,
});

export const registerUser = (payload, message) => ({
    type: REGISTER_USER,
    payload,
    message,
});

export const registerUserSuccess = (user) => ({
    type: REGISTER_USER_SUCCESS,
    payload: user,
});

export const registerUserError = () => ({
    type: REGISTER_USER_ERROR,
});

// Account Invoices
export const fetchAccountInvoices = () => ({
    type: FETCH_ACCOUNT_INVOICES,
});

export const fetchAccountInvoicesSuccess = (data) => ({
    type: FETCH_ACCOUNT_INVOICES_SUCCESS,
    payload: { data },
});

export const fetchAccountInvoicesError = () => ({
    type: FETCH_ACCOUNT_INVOICES_ERROR,
});
